// TODO: add tolgee
// TODO: add ZAI use cases

export const jobTypeOptions = [
  {
    label: 'Audience analysis',
    value: 'audience_analysis',
    description: 'Analysing what type of content a certain audience engages the most with.',
  },
  {
    label: 'Brand analysis',
    value: 'brand_competitor_benchmark_analysis',
    description: 'Analysing brands, competitors or benchmarks.',
  },
  {
    label: 'Creative Brief',
    value: 'briefing',
    description: 'Compiling creative references when setting a brief.',
  },
  {
    label: 'Campaign analysis',
    value: 'campaign_analysis',
    description: 'Analysing campaigns performance.',
  },
  {
    label: 'Client Pitch',
    value: 'client_pitch',
    description: 'A creative strategy for a future client.',
  },
  {
    label: 'Creator analysis',
    value: 'creator_analysis',
    description: 'Choosing the ideal creators for your strategy.',
  },
  {
    label: 'Territory analysis',
    value: 'passion_point_analysis',
    description: 'Choosing the cultural opportunities for your strategy.',
  },
  {
    label: 'Weekly agenda',
    value: 'weekly_agenda',
    description: 'Analysing what has been happening each week to share at your weekly meetings.',
  },
  {
    label: 'Other',
    value: 'other',
    description: 'Chose this option if non of the above fit your job to be done.',
  },
  {
    label: 'Report',
    value: 'report',
    description: 'This job was created from a legacy Report.',
  },
]
